import { useState, useEffect, Dispatch, SetStateAction } from 'react';
import {
  IMassMailingLog,
  IMassMailingLogSearchFilterDTO,
  massMailingLogSearch,
} from 'wisestep-api';

const useMassMailingLogSearch = (
  query: IMassMailingLogSearchFilterDTO,
  setLoader: Dispatch<SetStateAction<boolean>>
): [IMassMailingLog[], number] => {
  const [vendorsList, setVendorList] = useState<IMassMailingLog[]>();
  const [totatlCount, setTotatlCount] = useState<number>(0);

  useEffect(() => {
    const fetchVendors = async () => {
      try {
        setLoader(true);
        const response = await massMailingLogSearch(query);
        setTotatlCount(Number(response.headers['x-total-count']));
        setLoader(false);
        setVendorList(response.data);
      } catch (e) {
        setLoader(false);
      }
    };

    fetchVendors();
  }, [query, setLoader]);
  return [vendorsList ?? ([] as IMassMailingLog[]), totatlCount];
};
export default useMassMailingLogSearch;
